<div class="mainContainer mt-5 d-flex flex-column align-items-center">
  <div class="vMax wrap">
    <div class="heroWrap">
      <h2 class="headingWL">Careers</h2>
    </div>
    <div class="wrapper">
      <div class="cardWrap">
        <p class="vtext1">
          Virsa provides skills that last for a lifetime! Virsa is on a mission
          to make every human connect with their roots and live an enjoyable,
          extraordinary, fulfilling life. Virsa connects the learners with the
          legends who have mastered the path of Performing Arts. If you are
          interested in building a sustainable and rewarding career with a
          progressive team and want to create a long lasting impact in the life
          of fellow learners.
        </p>
        <p>Join Us</p>
        <p>
          Share with us your resume with a cover note at
          <a href="mailto:care@Virsaindia.com" style="text-decoration: solid; color: black">care@Virsaindia.com</a>
        </p>
      </div>
      <div class="cardWrap">
        <h6 class="headingBS">
          Current Job Openings <span>with Virsa :</span>
        </h6>
        <ul>
          <li *ngFor="let item of jobs">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>